<template>
  <a :href="link" class="container">
    <div class="title">
      <img :src="titleImgs" alt="">
    </div>
    <div class="product">
      <div class="img">
        <img :src="cover" alt="">
      </div>
      <div class="desc">
        <span>{{desc}}</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "card",
  props:{
    titleImg: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    cover: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    }
  },
  components: {},
  data() {
    return {
      titleImgs: require(`@/assets/jdSignal/pc/${this.titleImg}`)
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  margin-top: 41px;
  width: 346px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title img{
    height: 46px;
  }
  .product{
    margin-top: 17px;
    width: 346px;
    border: 1px solid #F2F2F2;
    border-radius: 5px;

    img{
      width: 100%;
      height: 215px;
      background: #EDEDED;
      border-radius: 5px 5px 0 0;
    }

    .desc{
      padding: 12px 15px 27px 14px;
      height: 44px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }

}
</style>